import { ExecKpiFamilyCard } from "@/components/executive/ExecKpiFamilyCard";
import type { ExecKpiFamily } from "@/types/executive";

interface ExecKpiGridProps {
  families: ExecKpiFamily[];
  orgSlug: string;
}

export function ExecKpiGrid({ families, orgSlug }: ExecKpiGridProps) {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {families.map((family) => (
        <ExecKpiFamilyCard key={family.id} family={family} orgSlug={orgSlug} />
      ))}
    </div>
  );
}
